import Rellax from 'rellax'
const rellax = new Rellax('.rellax', {
    speed: 2,
    center:true
})